/* MeineMarine – verpflichtende bewusste Größenauswahl v7 */
(function () {
  const SIZE_NAMES = ['size', 'größe', 'grösse', 'groesse'];
  const PROMPT = 'Bitte Größe wählen';
  const NOTICE_TEXT = 'Bitte wählen Sie eine Größe aus.';

  const norm = (s) => (s || '').trim().toLocaleLowerCase('de-DE');
  const isSizeName = (s) => SIZE_NAMES.includes(norm(s));

  function findSizeGroups(root = document) {
    const groups = [];
    root.querySelectorAll('fieldset').forEach((fieldset) => {
      const legend = fieldset.querySelector('legend');
      const firstRadio = fieldset.querySelector('input[type="radio"]');
      if ((legend && isSizeName(legend.textContent)) || (firstRadio && isSizeName(firstRadio.name))) groups.push({ type: 'radio', element: fieldset });
    });
    root.querySelectorAll('select').forEach((select) => {
      const rawName = (select.name || '').replace(/^options\[/, '').replace(/\]$/, '');
      const label = select.id ? root.querySelector('label[for="' + select.id + '"]') || document.querySelector('label[for="' + select.id + '"]') : null;
      if (isSizeName(rawName) || (label && isSizeName(label.textContent))) groups.push({ type: 'select', element: select });
    });
    return groups;
  }

  function nearestProductScope(el) {
    return el.closest('.product, .product__info-container, section, product-modal, quick-add-modal') || document;
  }

  function purchaseControls(scope) {
    const form = scope.querySelector('product-form form, form[action*="/cart/add"]');
    const productForm = form ? form.closest('product-form') : null;
    const button = productForm ? productForm.querySelector('[type="submit"]') : form?.querySelector('[type="submit"]');
    const variantInput = form?.querySelector('input[name="id"]');
    const payments = Array.from(scope.querySelectorAll('.shopify-payment-button'));
    return { form, productForm, button, variantInput, payments };
  }

  function ensureNotice(group) {
    let notice = group.element.parentElement?.querySelector(':scope > .mm-size-notice');
    if (!notice) {
      notice = document.createElement('p');
      notice.className = 'mm-size-notice';
      notice.setAttribute('role', 'alert');
      notice.setAttribute('aria-live', 'polite');
      notice.textContent = NOTICE_TEXT;
      notice.style.margin = '0.65rem 0 0';
      notice.style.fontSize = '1.35rem';
      notice.style.fontWeight = '600';
      notice.style.color = '#b42318';
      group.element.insertAdjacentElement('afterend', notice);
    }
    return notice;
  }

  function showNotice(group) { ensureNotice(group).hidden = false; }
  function hideNotice(group) { ensureNotice(group).hidden = true; }

  function clearSize(group) {
    if (group.type === 'radio') {
      group.element.querySelectorAll('input[type="radio"]').forEach((radio) => {
        radio.checked = false;
        radio.removeAttribute('checked');
      });
    } else {
      const select = group.element;
      let placeholder = select.querySelector('option[data-mm-size-placeholder]');
      if (!placeholder) {
        placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = PROMPT;
        placeholder.disabled = true;
        placeholder.dataset.mmSizePlaceholder = 'true';
        select.insertBefore(placeholder, select.firstChild);
      }
      placeholder.selected = true;
      select.value = '';
    }
  }

  function selectedSize(group) {
    return group.type === 'radio'
      ? group.element.querySelector('input[type="radio"]:checked')?.value || ''
      : group.element.value || '';
  }

  function pickerData(group) {
    const picker = group.element.closest('variant-radios, variant-selects');
    const scope = nearestProductScope(group.element);
    const json = picker?.querySelector('script[type="application/json"]') || scope.querySelector('variant-radios script[type="application/json"], variant-selects script[type="application/json"]');
    if (!json) return null;
    let variants;
    try { variants = JSON.parse(json.textContent); } catch (error) { return null; }
    const controls = picker ? Array.from(picker.querySelectorAll('fieldset, select')) : [];
    const names = controls.map((control) => control.matches('select')
      ? (control.name || '').replace(/^options\[/, '').replace(/\]$/, '')
      : (control.querySelector('input[type="radio"]')?.name || control.querySelector('legend')?.textContent || '').trim());
    const sizeIndex = names.findIndex(isSizeName);
    if (sizeIndex < 0) return null;
    const selected = controls.map((control) => control.matches('select')
      ? control.value || ''
      : control.querySelector('input[type="radio"]:checked')?.value || '');
    return { picker, variants: Array.isArray(variants) ? variants : [], sizeIndex, selected };
  }

  function availableSizeValues(group) {
    const data = pickerData(group);
    if (!data) return null;
    const candidates = data.variants.filter((variant) => variant.available !== false && Array.isArray(variant.options) && data.selected.every((value, index) => index === data.sizeIndex || !value || variant.options[index] === value));
    return [...new Set(candidates.map((variant) => variant.options[data.sizeIndex]).filter(Boolean))];
  }

  function setSize(group, value) {
    if (group.type === 'radio') {
      const input = Array.from(group.element.querySelectorAll('input[type="radio"]')).find((radio) => radio.value === value);
      if (!input) return false;
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      const option = Array.from(group.element.options).find((item) => item.value === value);
      if (!option) return false;
      group.element.value = value;
      group.element.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return true;
  }

  function hasSize(group) { return Boolean(selectedSize(group)); }

  function lock(group) {
    const scope = nearestProductScope(group.element);
    const { button, variantInput, payments } = purchaseControls(scope);
    showNotice(group);
    if (!button) return;
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    const span = button.querySelector('span');
    if (span) {
      if (!button.dataset.mmOriginalText) button.dataset.mmOriginalText = span.textContent;
      span.textContent = PROMPT;
    }
    if (variantInput) variantInput.disabled = true;
    payments.forEach((payment) => { payment.hidden = true; });
  }

  function unlock(group) {
    const scope = nearestProductScope(group.element);
    const { button, variantInput, payments } = purchaseControls(scope);
    hideNotice(group);
    if (!button) return;
    if (variantInput) variantInput.disabled = false;
    button.disabled = false;
    button.removeAttribute('aria-disabled');
    const span = button.querySelector('span');
    if (span && span.textContent === PROMPT) span.textContent = button.dataset.mmOriginalText || window.variantStrings?.addToCart || 'In den Warenkorb legen';
    payments.forEach((payment) => { payment.hidden = false; });
  }

  function domSizeValues(group) {
    if (group.type === 'radio') {
      return [...new Set(Array.from(group.element.querySelectorAll('input[type="radio"]')).filter((input) => !input.disabled && input.value).map((input) => input.value))];
    }
    return [...new Set(Array.from(group.element.options).filter((option) => !option.disabled && option.value && !option.dataset.mmSizePlaceholder).map((option) => option.value))];
  }

  function effectiveSizeValues(group) {
    const values = availableSizeValues(group);
    return values === null ? domSizeValues(group) : values;
  }

  function confirmSize(group, value) {
    if (!setSize(group, value)) return false;
    group.element.dataset.mmSizeChosen = 'true';
    setTimeout(() => unlock(group), 0);
    setTimeout(() => unlock(group), 150);
    return true;
  }

  function reconcile(group, initial = false) {
    const values = effectiveSizeValues(group);
    const current = selectedSize(group);
    if (values.length === 1) {
      if (current !== values[0] && !confirmSize(group, values[0])) {
        group.element.dataset.mmSizeChosen = 'false';
        clearSize(group);
        lock(group);
      }
      return;
    }
    if (values.length > 1 && current && values.includes(current) && !initial) {
      if (group.element.dataset.mmSizeChosen === 'true') unlock(group);
      return;
    }
    if (initial || values.length !== 1 || !current || !values.includes(current)) {
      group.element.dataset.mmSizeChosen = 'false';
      clearSize(group);
      lock(group);
    }
  }

  function initializeGroup(group) {
    if (group.element.dataset.mmRequiredSize === 'ready') return;
    group.element.dataset.mmRequiredSize = 'ready';
    group.element.dataset.mmSizeChosen = 'false';

    const initializeState = () => {
      if (group.element.dataset.mmSizeChosen === 'true') return;
      const domValues = domSizeValues(group);
      if (domValues.length === 1) {
        confirmSize(group, domValues[0]);
        return;
      }
      reconcile(group, true);
    };

    group.element.addEventListener('change', (event) => {
      const validChange = group.type === 'radio' ? event.target.matches('input[type="radio"]') : event.target === group.element;
      if (!validChange) return;
      const values = effectiveSizeValues(group);
      if (hasSize(group) && values.includes(selectedSize(group))) {
        group.element.dataset.mmSizeChosen = 'true';
        setTimeout(() => unlock(group), 0);
        setTimeout(() => unlock(group), 150);
      } else {
        group.element.dataset.mmSizeChosen = 'false';
        reconcile(group);
      }
    });
    const observer = new MutationObserver(() => {
      if (group.element.dataset.mmSizeChosen !== 'true') reconcile(group, true);
    });
    observer.observe(group.element, { attributes: true, childList: true, subtree: true });
  }

  function init(root = document) { findSizeGroups(root).forEach(initializeGroup); }
  init();
  document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  window.addEventListener('load', () => init(), { once: true });
  window.addEventListener('pageshow', () => init());

  const documentObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => { if (node.nodeType === 1) init(node); }));
  });
  documentObserver.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('click', (event) => {
    const input = event.target.closest?.('input[type="radio"]') || event.target.closest?.('label')?.querySelector('input[type="radio"]');
    const fieldset = input?.closest('fieldset[data-mm-required-size="ready"]');
    if (input && fieldset && input.checked) {if (input && fieldset) {}
      const group = { type: 'radio', element: fieldset };
      fieldset.dataset.mmSizeChosen = 'true';
      unlock(group);
    }
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target instanceof HTMLInputElement && event.target.matches('input[type="radio"]')) {
      const fieldset = event.target.closest('fieldset[data-mm-required-size="ready"]');
      if (fieldset && event.target.checked) {
        const group = { type: 'radio', element: fieldset };
        const values = effectiveSizeValues(group);
        if (values.includes(event.target.value)) {
          fieldset.dataset.mmSizeChosen = 'true';
          unlock(group);
        }
      }
    }
  }, true);

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof HTMLElement) || !event.target.matches('variant-radios input, variant-selects select')) return;
    document.querySelectorAll('[data-mm-required-size="ready"]').forEach((element) => {
      const group = { type: element.matches('select') ? 'select' : 'radio', element };
      if (group.type === 'radio' && !element.matches('fieldset')) return;
      if (group.element.dataset.mmSizeChosen !== 'true') reconcile(group, true);
    });
  });

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]')) return;
    const scope = form.closest('.product, section, product-modal, quick-add-modal') || document;
    const group = findSizeGroups(scope)[0];
    if (!group) return;
    const submitValues = effectiveSizeValues(group);
    const submitSize = selectedSize(group);
    if (submitValues.length === 1 && submitSize === submitValues[0]) {
      group.element.dataset.mmSizeChosen = 'true';
      unlock(group);
      return;
    }
    if (group.element.dataset.mmSizeChosen === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    lock(group);
    ensureNotice(group).scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);
})();

if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span')?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            this.error = true;
            return;
          }
          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => this.cart.renderContents(response));
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart?.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner')?.classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) this.errorMessage.textContent = errorMessage;
    }
  });
}
